import * as size from '@constant/size';
import * as color from '@constant/color';
import { SERVICE } from '@config/environment';
import { EService } from '@datatype/type';

// auth

export const AUTH_BOX_DESIGN = { width: size.AUTH_BOX_WIDTH };

export const AUTH_TEXT_DESIGN = {
  text: { size: 'medium' },
  box: {
    width: size.AUTH_BLOCK_WIDTH,
    height: size.AUTH_BLOCK_HEIGHT,
    alignX: 'center',
  },
} as const;

export const AUTH_INPUT_DESIGN = {
  text: { size: 'medium' },
  box: {
    width: size.AUTH_BLOCK_WIDTH,
    height: size.AUTH_BLOCK_HEIGHT,
    borderWidth: '1px',
    borderColor: color.GRAY_1,
    alignX: 'left',
    padding: `0 ${size.MARGIN_1} 0 ${size.MARGIN_1}`,
  },
} as const;

export const PASSWORD_INPUT_DESIGN = {
  text: { size: 'medium' },
  box: {
    width: size.AUTH_BLOCK_WIDTH,
    height: size.AUTH_BLOCK_HEIGHT,
    borderWidth: '1px',
    borderColor: color.GRAY_1,
    alignX: 'left',
    padding: `0 ${size.MARGIN_4} 0 ${size.MARGIN_1}`,
  },
} as const;

export const AUTH_LOGO_DESIGN = {
  box: {
    gap: size.MARGIN_1,
    width: '100%',
    alignX: 'center',
  },
  image: { height: '60px' },
  text: { size: 'big', color: color.BLACK_2, bold: true },
} as const;

export const AUTH_BUTTON_DESIGN = {
  text: { size: 'medium', bold: false, color: color.WHITE_1 },
  box: {
    height: size.AUTH_BLOCK_HEIGHT,
    width: size.AUTH_BLOCK_WIDTH,
    backgroundColor: color.BROWN_1,
    event: { cursor: 'pointer' },
  },
} as const;

export const createAuthButtonDesign = () => ({
  ...AUTH_BUTTON_DESIGN,
  box: {
    ...AUTH_BUTTON_DESIGN.box,
    backgroundColor: SERVICE === EService.GRIDGIO ? color.CYAN_1 : color.BROWN_1,
  },
});

export const createSignTextDesign = () => ({
  text: {
    size: 'medium' as const,
    color: SERVICE === EService.GRIDGIO ? color.CYAN_1 : color.BROWN_1,
    bold: false,
    underline: true,
  },
  box: { event: { cursor: 'pointer' as const } },
});

export const ERROR_TEXT_DESIGN = {
  text: { size: 'tiny', color: color.ERROR_RED },
  box: { margin: '5px 0px 5px 0px', alignX: 'left' },
} as const;

// cloze grammar
export const GRAMMAR_CHIP_HEIGHT_JP = '40px';
export const GRAMMAR_CHIP_HEIGHT_EN = '30px';
export const GRAMMAR_CHIP_PADDING = '0 10px';
